<template>
  <va-sidebar :minimized="minimized">
    <template slot="menu">
      <template v-for="(item, key) in items">
        <va-sidebar-link-group
          :key="key"
          :minimized="minimized"
          :icon="[ 'sidebar-menu-item-icon ', item.meta.iconClass ]"
          v-if="item.children && item.visible"
          :title="$t(item.displayName)"
          :children="item.children"
        >
          <va-sidebar-link
            v-for="(subMenuItem, key) in item.children"
            v-show="subMenuItem.visible"
            :key="key"
            :to="{ name: subMenuItem.name }"
            :title="$t(subMenuItem.displayName)"
          />
        </va-sidebar-link-group>
        <va-sidebar-link
          v-else-if="item.visible"
          :key="key"
          :minimized="minimized"
          :activeByDefault="item.name === $route.name"
          :icon="[ 'sidebar-menu-item-icon sidebar-link-icon-color', item.meta.iconClass ]"
          :to="{ name: item.name }">
          <span slot="title">{{ $t(item.displayName) }}</span>
        </va-sidebar-link>
      </template>
    </template>
  </va-sidebar>
</template>

<script>

export default {
  name: 'app-sidebar',
  components: {
  },
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      items: {},
      modeloCanonico: this.$store.state.parametrizacao.rotas.routes,
      currentPrivileges: this.$store.state.authentication.user.privilegios,
      schemaNavigation: ['displayName', 'name', 'metaNavigation', 'children'],
      navigationModel: []
    }
  },
  created () {
    if (this.$store.state.authentication.user && this.$store.state.authentication.user.privilegios) {
      this.currentPrivileges = this.$store.state.authentication.user.privilegios
      this.modeloCanonico = this.$store.state.parametrizacao.rotas.routes
      this.gerarSidebar()
    } else {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type.startsWith('authentication')) {
          if (state.authentication.user && state.authentication.user.privilegios) { 
            this.currentPrivileges = this.$store.state.authentication.user.privilegios
            this.modeloCanonico = this.$store.state.parametrizacao.rotas.routes
            this.gerarSidebar()
          }
        }
      })
    }
  },
  methods: {
    gerarSidebar() {
      let navigationmodel = []
      let parsedNode = {}
      this.modeloCanonico.forEach(node => {
        parsedNode = this.parseNavigationNode(node, this.currentPrivileges)
        if(this.existe(parsedNode)) {
          if(Array.isArray(parsedNode)) {
            navigationmodel = [...navigationmodel, ...parsedNode]
          } else {
            navigationmodel.push(parsedNode)
          }
        }
      })
      this.items = navigationmodel
    },
    existe(el) {
      return typeof el !== 'undefined' && el != null
    },
    isNodeVisible(privilegios, resource_privileges) {
      let is_visible = true
      resource_privileges.forEach(privilege => {
        is_visible = is_visible && privilegios.includes(privilege)
      })
      return is_visible
    },
    parseNavigationNode(node, privilegios) {
        let navigation_node = null
        let visivel = false
        if((this.existe(node[this.schemaNavigation[0]]) && this.existe(node[this.schemaNavigation[1]])) || this.existe(node[this.schemaNavigation[3]])) {
            navigation_node = {}
            if(!this.existe(node['children'])) {
              if(this.existe(node['privileges'])) {
                visivel = this.isNodeVisible(privilegios, node['privileges'])
              } else {
                visivel = true
              }
            } else if(this.existe(node[this.schemaNavigation[0]]) && this.existe(node[this.schemaNavigation[1]])) {
              navigation_node['disabled'] = true
            }
            this.schemaNavigation.forEach(attr => {
                if(this.existe(node[attr])) {
                    if(attr === 'metaNavigation') {
                        navigation_node['meta'] = node[attr]
                    } else if(attr === 'children') {
                        let child_nodes = []
                        let parsed_child = {}
                        node[attr].forEach(child => {
                            parsed_child = this.parseNavigationNode(child, privilegios)
                            if(this.existe(parsed_child)) {
                                visivel = visivel || parsed_child.visible
                                child_nodes.push(parsed_child)
                            }
                        })
                        navigation_node[attr] = child_nodes
                    } else {
                        navigation_node[attr] = node[attr]
                    }
                }
            })
            navigation_node['visible'] = visivel
        }
        if(navigation_node != null && this.existe(navigation_node['children']) && 
          (!this.existe(node[this.schemaNavigation[1]]) || !this.existe(node[this.schemaNavigation[0]]))) {
            if(navigation_node['children'].length <=0) {
              return null //é um caminho do router
            } else {
              return navigation_node['children'] /*é um raiz sem display (ex.: /sp360), então retorna uma array de todos os elementos
              para serem desempacotados depois*/
            }
        }
        return navigation_node
      }
  },
}
</script>

<style lang="scss">
  .sidebar-link-icon-color {
    color: $vue-green;
  }
  @media (max-width: 767.98px)
  {
    .va-sidebar
    {
      top: 4.0625rem !important
    }
  }

// /deep/ .va-sidebar-link{
//   color: $themes.success
// }
// /deep/ .va-topbar-link__content{
//   color: $themes.success
// }
// /deep/ .va-topbar-link__content__icon{
//   color: $themes.success
// }

// /deep/ .va-topbar-link-group__expanded-icon{
//   color: $themes.success
// }

</style>
